export default __webpack_public_path__ + "static/media/profile-experience.1b2397ad.svg";